import { ReactComponent as WarningIcon } from "@assets/icons/warning.svg";
import style from "./style.module.scss";

interface CreditLimitModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  functionality?: string; // Optional, can be used for additional functionality
}

export function CreditLimitModal({
  open,
  setOpen,
  functionality,
}: CreditLimitModalProps) {
  // get users email from local storage
  const userEmail = localStorage.getItem("email") || "";

  const userEmailURL = encodeURIComponent(userEmail);

  const toolAtWork = encodeURIComponent(
    functionality
      ? functionality
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "General Assistance",
  );

  const mailtoLink = `mailto:admin@janusadvisoryinc.com?subject=Credit%20Limit%20Assistance&body=Registered%20Email%20Address:%20${userEmailURL}%0D%0ATool%20At%20Work:%20${toolAtWork}%0D%0A%0D%0AHello,%0D%0A%0D%0AI%20need%20assistance%20with%20my%20credit%20limit.%20Please%20increase%20my%20credits%20so%20I%20can%20continue%20working.%0D%0A%0D%0AThank%20you.`;
  if (!open) return null;

  // const message = (() => {
  //   switch (functionality) {
  //     case "concept note converter":
  //       return "It looks like this submission will exceed your credit limit and you will need to add more to continue using this Assistant without interruptions. Please contact us so we can add more credits to your account.";
  //     default:
  //       return "You've reached your credit limit. Please contact us to add more credits.";
  //   }
  // })();

  return (
    <div className={style.addDisclaimer}>
      <div className={style.addDisclaimerTooltip}>
        <div className={style.addDisclaimerTooltipTop}>
          <div className={style.addDisclaimerTooltipTopHeader}>
            <WarningIcon className={style.warningIcon} />
            Credit Limit Reached
          </div>
          <div
            style={{
              marginLeft: "auto",
              cursor: "pointer",
              fontSize: "22px",
              color: "#000",
            }}
            onClick={() => {
              setOpen(false);
            }}
          >
            ×
          </div>
        </div>
        <div className={style.addDisclaimerTooltipContent}>
          It looks like this submission will exceed your credit limit and you
          will need to add more to continue using this Assistant without
          interruptions. Please contact us so we can add more credits to your
          account:
          <br />
          <strong>admin@janusadvisoryinc.com</strong>
        </div>
        <div className={style.addDisclaimerTooltipFooter}>
          <button
            onClick={(e) => {
              e.preventDefault();
              window.location.href = mailtoLink;
            }}
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
}
